module.exports = __webpack_public_path__ + "img/bud-left.31a83511.svg";